import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();

  const cols = [
    { titleKey: "footer_col1", links: ["footer_col1_l1","footer_col1_l2","footer_col1_l3","footer_col1_l4"] },
    { titleKey: "footer_col2", links: ["footer_col2_l1","footer_col2_l2","footer_col2_l3","footer_col2_l4"] },
    { titleKey: "footer_col3", links: ["footer_col3_l1","footer_col3_l2","footer_col3_l3","footer_col3_l4"] },
    { titleKey: "footer_col4", links: ["footer_col4_l1","footer_col4_l2","footer_col4_l3","footer_col4_l4"] },
  ];

  return (
    <footer className="bg-stone-900 text-white">
      <div className="bg-emerald-800 py-10 md:py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-1">{t("footer_cta_title")}</h3>
            <p className="text-emerald-200 text-sm">{t("footer_cta_desc")}</p>
          </div>
          <a href="#contact" className="bg-white text-emerald-800 font-bold px-8 py-3.5 rounded-full hover:bg-emerald-50 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0">{t("footer_cta_btn")}</a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-10 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-700">
                <i className="ri-shield-star-line text-white text-lg"></i>
              </div>
              <div>
                <div className="font-bold text-sm leading-tight tracking-wide text-white">GPFG</div>
                <div className="text-xs tracking-widest text-emerald-400">FUND GLOBAL</div>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-5">{t("footer_about_desc")}</p>
            <div className="flex items-center gap-3">
              {["ri-twitter-x-line","ri-linkedin-line","ri-youtube-line","ri-telegram-line"].map((icon) => (
                <a key={icon} href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-800 text-stone-400 hover:text-white hover:bg-emerald-700 transition-colors cursor-pointer">
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>
          {cols.map((col) => (
            <div key={col.titleKey}>
              <div className="text-xs font-bold uppercase tracking-widest text-stone-400 mb-4">{t(col.titleKey)}</div>
              <ul className="flex flex-col gap-3">
                {col.links.map((lk) => (
                  <li key={lk}><a href="#" className="text-sm text-stone-400 hover:text-white transition-colors cursor-pointer">{t(lk)}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-stone-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs">{t("footer_copy")}</p>
          <p className="text-stone-600 text-xs text-center sm:text-right max-w-md">{t("footer_disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}
